import App from "../website/App";
import BillboardDetail from "../website/sections/billboard-detail/BillboardDetail";

window.App = App;
window.Section = BillboardDetail;